import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { Kop } from "@/lib/kop";
import { TEMPLATES, tglID } from "@/lib/suratTemplates";
import { usePejabat } from "@/context/PejabatContext";
import { BULAN_ID } from "@/pages/AgendaSurat";

const BLN = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const cell = "border border-black px-2 py-1";

export default function CetakRekapSurat() {
  const [params] = useSearchParams();
  const tahun = params.get("tahun") || String(new Date().getFullYear());
  const bulan = Number(params.get("bulan")) || 0;
  const [d, setD] = useState(null);
  const { pejabat: pj } = usePejabat();
  useEffect(() => {
    api.get("/stats/surat", { params: { tahun } }).then((r) => setD(r.data));
  }, [tahun]);

  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const periode = bulan ? `BULAN ${BULAN_ID[bulan - 1].toUpperCase()} ${tahun}` : `TAHUN ${tahun}`;
  const count = (id) => (bulan ? d.bulan[bulan - 1].per_jenis[id] || 0 : d.per_jenis.find((j) => j.jenis === id)?.total || 0);
  const total = d ? (bulan ? d.bulan[bulan - 1].total : d.total) : 0;

  return (
    <div className="min-h-screen bg-slate-300 py-8 px-4 print:p-0 print:bg-white" data-testid="cetak-rekap-surat-page">
      <style>{"@media print { @page { size: A4 portrait; margin: 0; } }"}</style>
      <div className="no-print max-w-[210mm] mx-auto flex justify-between mb-4">
        <a href="/agenda" className="inline-flex items-center gap-2 text-sm text-slate-700" data-testid="cetak-rekap-surat-back"><ArrowLeft className="h-4 w-4" /> Buku Agenda</a>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 bg-[#0b4f4a] text-white text-sm rounded-lg px-4 py-2" data-testid="cetak-rekap-surat-print">
          <Printer className="h-4 w-4" /> Cetak / Simpan PDF
        </button>
      </div>
      <div className="mx-auto bg-white text-black w-[210mm] min-h-[297mm] px-[18mm] py-[14mm] shadow-xl print:shadow-none text-[14px]" style={{ fontFamily: "'Times New Roman', serif" }}>
        <Kop />
        <div className="text-center mt-5">
          <div className="font-bold underline text-[16px]">REKAPITULASI PELAYANAN SURAT KETERANGAN</div>
          <div data-testid="rekap-surat-periode">{periode}</div>
        </div>
        {d && (
          <table className="w-full border-collapse mt-5" data-testid="rekap-surat-print-table">
            <thead>
              <tr className="bg-slate-100">
                <th className={cell}>No</th><th className={`${cell} text-left`}>Jenis Surat</th>
                {!bulan && BLN.map((b) => <th key={b} className={`${cell} text-[11px]`}>{b}</th>)}
                <th className={cell}>Jumlah</th>
              </tr>
            </thead>
            <tbody>
              {TEMPLATES.map((t, i) => (
                <tr key={t.id}>
                  <td className={`${cell} text-center`}>{i + 1}</td>
                  <td className={`${cell} text-[13px]`}>{t.judul}</td>
                  {!bulan && d.bulan.map((b) => <td key={b.bulan} className={`${cell} text-center text-[12px]`}>{b.per_jenis[t.id] || "-"}</td>)}
                  <td className={`${cell} text-center font-semibold`}>{count(t.id)}</td>
                </tr>
              ))}
              <tr className="font-bold bg-slate-100">
                <td className={cell} colSpan={2}>JUMLAH</td>
                {!bulan && d.bulan.map((b) => <td key={b.bulan} className={`${cell} text-center text-[12px]`}>{b.total}</td>)}
                <td className={`${cell} text-center`} data-testid="rekap-surat-print-total">{total}</td>
              </tr>
            </tbody>
          </table>
        )}
        <div className="flex justify-end mt-10">
          <div className="text-center w-72">
            <div>Timika, {tglID(today)}</div>
            <div className="font-semibold">{pj.jabatan}</div>
            {pj.ttd ? <img src={pj.ttd} alt="Tanda tangan" className="h-20 mx-auto object-contain" data-testid="rekap-surat-ttd" /> : <div className="h-20" />}
            <div className="font-bold underline">{pj.nama}</div>
            {pj.pangkat && <div>{pj.pangkat}</div>}
            <div>NIP. {pj.nip}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
